import { useCallback, useMemo, useState } from 'react'

import { useFxQuoteLazyQuery } from '@shared/graphql'

import { TransferWithFxContext } from './context'

import type { FxQuote, GetFxQuoteInput } from '@shared/graphql'

export interface TransferWithFxProviderProps {
  /**
   * React Node Children.
   */
  children?: React.ReactNode
}

export const TransferWithFxProvider: React.FC<TransferWithFxProviderProps> = ({
  children,
}) => {
  const [latestQuote, setLatestQuote] = useState<FxQuote | undefined>()

  const [
    refetchQuote,
    { loading: quoteLoading, called: quoteCalled, error: quoteError },
  ] = useFxQuoteLazyQuery({
    fetchPolicy: 'no-cache',
    nextFetchPolicy: 'no-cache',
  })

  const refetch = useCallback(
    async (input: GetFxQuoteInput) => {
      const result = await refetchQuote({
        variables: {
          input,
        },
        onCompleted: (data) => {
          setLatestQuote(data.fxQuote)
        },
      })

      return result.data?.fxQuote
    },
    [refetchQuote],
  )

  return (
    <TransferWithFxContext.Provider
      value={{
        ...useMemo(
          () => ({
            refetch,
            quote: latestQuote,
            loading: quoteLoading || !quoteCalled,
            error: quoteError,
          }),
          [refetch, latestQuote, quoteLoading, quoteCalled, quoteError],
        ),
      }}
    >
      {children}
    </TransferWithFxContext.Provider>
  )
}
